import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class HR extends React.Component {
  render() {
    const hrClasses = classNames(
      "hr",
      {
        vertical: this.props.vertical,
        [this.props.theme]: this.props.theme,
        mutted: this.props.mutted,
        bold: this.props.bold,
        [`margin-${this.props.margin}`]: this.props.margin
      },
      this.props.className
    );

    return React.createElement("hr", {
      className: hrClasses
    });
  }
}

HR.defaultProps = {
  vertical: false,
  theme: false,
  mutted: false,
  bold: false,
  margin: false
};

HR.propTypes = {
  vertical: PropTypes.bool,
  theme: PropTypes.oneOf([false, "dashed"]),
  mutted: PropTypes.bool,
  bold: PropTypes.bool,
  margin: PropTypes.oneOf([
    false,
    "no",
    "no-top",
    "no-bottom",
    "left-right-auto"
  ]),
  className: PropTypes.string
};

export default HR;
